/**!
 * Created by Leonardo Cheslacki on 03/10/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';

import FormController from './FormController';

import WithType from './../helpers/WithType';

let _this = {};

/**
 *
 */
class FormRadio extends FormController {
    /**
     *
     * @param props
     * @param main
     */
    constructor(props, main) {
        super(props);

        this.props = props;
        this.main = main;

        this.state = {
            radios: []
        };

        _this = this;
    };

    $functions = {
        /**
         *
         */
        handle: function () {
        }
    };

    /**
     *
     * @param _this_frame
     */
    setRadios = (_this_frame) => {
        let radios = this.verifyField(_this_frame, 'occ_radio.children', false, []);
        this.setState({...this.state, radios: radios})
    };

    initFocus = (key) => {
        let
            radios = this.state.radios,
            radio = this.isArrayIf(radios) ? radios[key] : null;

        radio && this.setStateOccurrence(radio, {
            focus: false,
            value: this.toNumber(radio.name)
        });
    };

    /**
     *
     * @param value
     */
    setFocus = (value) => {
        let radios = this.state.radios;

        if (radios) {
            radios.find((property) => {
                if (property.state.value.toString() === value.toString()) {
                    property.gotoAndStop('enabled');
                    property.state.focus = true;
                } else {
                    property.gotoAndStop('disabled');
                    property.state.focus = false;
                }
            });
        }
    };

    isFocus = () => {
        let radios = this.state.radios;

        if (radios) {
            let radio = radios.find((property) => {
                let {state: {focus}} = property;
                return focus === true;
            });

            return !_this.isEmpty(radio);
        }

        return false;
    };

    clearFocus = () => {
        let radios = this.state.radios;

        if (radios) {
            radios.find((property) => {
                property.gotoAndStop('disabled');
                property.state.focus = false;
            });
        }
    };
}

/**
 *
 * @type {{}}
 */
FormRadio.propTypes = {};

/**
 *
 * @type {{}}
 */
FormRadio.defaultProps = {};

/**
 *
 * @param ClassObject
 * @param className {className: 'className'}
 * @returns {function(*): function({}=): *} pass _this ClassMain (required) and props {} (optional)
 */
export default WithType(FormRadio, {className: 'FormRadio'});
